export default "__VITE_ASSET__Ovt8QbwD__"